import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} PassingPercentage
 * @property {number} current
 * @property {number[]} options
 */

/**
 * @typedef {object} AllowedAttempts
 * @property {number} current
 * @property {number[]} options
 */

/**
 * @typedef {object} SchoolAdminDashboard
 * @property {number} total_students
 * @property {number} total_teachers
 * @property {number} total_quests
 * @property {PassingPercentage} passing_percentage
 * @property {AllowedAttempts} allowed_attempts
 * @property {"en" | "hi" | null} locale
 */

export const useGetSchoolAdminDashboard = () => {
  const [dashboard, setDashboard] = useState(
    /** @type {SchoolAdminDashboard | null} */(null)
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { axiosInstance } = useAxios();

  /**
   * Fetch School Admin Dashboard
   * @returns {Promise<void>}
   */
  const getDashboard = async () => {
    try {
      setLoading(true);
      setError("");

      const url = `${TENANT_DOMAIN}/school/admin/dashboard`;
      const response = await axiosInstance.get(url);

      setDashboard(response.data?.data || null);
    } catch (err) {
      setDashboard(null);

      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    dashboard,
    loading,
    error,
    getDashboard,
  };
};
